import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const AddDepartment = ({ show, onClose, onCreated, refresh }) => { 
    const [name, setName] = useState(''); 
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [nameLengthError, setNameLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');

    // Handle changes in department name and ensure first letter is uppercase
    const handleNameChange = (e) => {
        let value = e.target.value; 
        // Capitalize the first letter
        value = value.charAt(0).toUpperCase() + value.slice(1);
        setName(value);

        // Clear name length error if input length is under the limit
        if (value.length <= 300) {
            setNameLengthError('');
        }
    };

    // Handle changes in description and ensure first letter is uppercase
    const handleDescriptionChange = (e) => {
        let value = e.target.value;
        // Capitalize the first letter
        value = value.charAt(0).toUpperCase() + value.slice(1);
        setDescription(value);

        // Check the length of the description and set error if exceeds 500
        if (value.length > 500) {
            setDescLengthError('Limit reached (max 500 characters)');
        } else {
            setDescLengthError('');
        }
    };

    const [data_name, setData] = useState([]);

    useEffect(() => {
        axios.get(`${baseURL}/department/list`)
            .then(response => {
                setData(response.data.data.data.map(mode => mode.department_name.toLowerCase()));
            })
            .catch(error => {
            console.log('There was an error fetching the data!', error);
            });
    }, []);
 

    const handleSubmit = () => {
        // Clear previous errors
        setErrors({});
        setNameLengthError('');
        setDescLengthError('');
    
        // Validation for department name
        if (!name) {
            setErrors(prev => ({
                ...prev,
                department_name: "This field is required"
            }));
            return;
        }  else if (data_name.includes(name.trim().toLowerCase())) {
            setErrors(prev => ({
                ...prev,
                department_name: "Name Already Exists."
            }));
            return;
        }
    
        // Validation for length of department name
        if (name.length > 300) {
            setNameLengthError('Limit reached (max 300 characters)');
            return;
        }
    
        if (description.length > 500) {
            setDescLengthError('Limit reached (max 500 characters)');
            return;
        }
    
        // Proceed with API call if validation passes
        axios.post(`${baseURL}/department`, { 
            department_name: name,
            description: description,
        })
        .then(() => {
            refresh();
            onClose();
            if (onCreated) onCreated();
            toast.success("Department Created successfully!"); 
        })
        .catch(error => {
            if (error.response?.status === 400) {
                // Check if the error response contains a message about the department already existing
                if (error.response.data?.message === 'Department already exists') {
                    setErrors(prev => ({
                        ...prev,
                        department_name: 'Department with this name already exists'
                    }));
                } else if (error.response.data.errors) {
                    // Handle other validation errors
                    setErrors(error.response.data.errors);
                }
            } else {
                console.error("Create failed:", error);
            }
        });
    };

    
    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Department</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Department Name<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Department Name" />
                        </div> */}
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                            Department Name<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className={`form-control`}
                                placeholder="Enter Department Name"
                                value={name}
                                maxLength={255}
                                onChange={handleNameChange}
                            />
                            {errors.department_name && (
                                <div className="text-danger">{errors.department_name}</div>
                            )}
                            {nameLengthError && (
                                <span className="text-danger">{nameLengthError}</span>
                            )}
                        </div>
                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Description" defaultValue={""} />
                        </div> */}
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={4}
                                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                placeholder="Description"
                                value={description}
                                maxLength={255}
                                onChange={handleDescriptionChange}
                            />
                            {descLengthError && (
                                <span className="text-danger">{descLengthError}</span>
                            )}
                        </div>
                    </div>
                    {/* <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Create Department</Link>
                    </div> */}
                      {/* <div className="d-flex justify-content-center gap-3 mt-4 mb-4">
                            <Button variant="secondary" size="sm" onClick={onClose}>Cancel</Button>
                            <Button variant="primary" size="sm" onClick={handleSubmit}>Create Department</Button>
                        </div> */}
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Department
                            <i className="fas fa-angle-double-right ms-2"></i>
                            </button>
                        </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddDepartment;
